import {createAsyncThunk} from "@reduxjs/toolkit";
import {iStateMessage} from "@/customTypes/GenericReduxTypes";


import {iGenericResponse} from "@/customTypes/CommonServiceTypes";
import {curryGetThunkName} from "@/projectUtils/ReduxUtil";
import {httpStatusCodes} from "@/customTypes/NetworkTypes";
import { userService,deliveryManService } from "@/services/api/cresivoxServer";
// import { deliveryManService } from "@/services/api/cresivoxServer";


import { REDUCER_NAME, iEmployeeDTO} from './Types';
const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);


export const addEmployee = createAsyncThunk<
iGenericResponse<any | null> | null,
iEmployeeDTO,
{
	rejectValue: iStateMessage;
}
>(
curriedGetThunkName("addEmployee"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async (payload, {rejectWithValue}) => {
	try {
		const response = await userService.addEmployee(payload);
		if (response) {
			const {httpStatusCode, data, message} = response;
			switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_OK: {
					if (data && data.data) {
						return {
							data: {
								orders: data.data,
								message,
							}
						};
					} else {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
				default: {
					return rejectWithValue({
						httpStatusCode,
						message,
					});
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);

export const updateEmployee = createAsyncThunk<
iGenericResponse<any | null> | null,
{employeeId:string, data: iEmployeeDTO},
{
	rejectValue: iStateMessage;
}
>(
curriedGetThunkName("updateEmployee"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async ({employeeId,data}, {rejectWithValue}) => {
	try {
		const response = await userService.updateEmployee(employeeId,data);
		if (response) {
			const {httpStatusCode, data, message} = response;

			switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_OK: {
					if (data && data.data) {
						return {
							data: {
								data: data.data,
								message,
							}
						};
					} else {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
				default: {
					return rejectWithValue({
						httpStatusCode,
						message,
					});
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);


export const getEmployeeList = createAsyncThunk<
  iGenericResponse<any | null> | null,
void,
  {
	  rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("getEmployeeList"),
  // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
  async (arg, {rejectWithValue}) => {
	  try {
		  const response = await userService.getEmployeeList();
		  if (response) {
			  const {httpStatusCode, data, message} = response;

			  switch (httpStatusCode) {
				  case httpStatusCodes.SUCCESS_OK: {
					  if (data && data.data) {
						  return {
							data:{
							  httpStatusCode,
							  data: data.data,
							  message,
							}
						  };
					  } else {
						  return rejectWithValue({
							  httpStatusCode,
							  message,
						  });
					  }
				  }
				  default: {
					  return rejectWithValue({
						  httpStatusCode,
						  message,
					  });
				  }
			  }
		  } else {
			  return rejectWithValue({
				  message: "No response received",
			  });
		  }
	  } catch (error) {
		  return rejectWithValue({
			  message: "Something went wrong",
		  });
	  }
  },
);


export const deleteDelivery = createAsyncThunk<
iGenericResponse<any | null> | null,
{userId:string},
{
	rejectValue: iStateMessage;
}
>(
curriedGetThunkName("deleteDelivery"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async ({userId}, {rejectWithValue}) => {
	try {

		const response = await deliveryManService.deleteDelivery(userId);
		if (response) {
			const {httpStatusCode, data, message} = response;

			switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_OK: {
					if (data && data.data) {
						return {
							
								data: data.data,
								message,
							
						};
					} else {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
				default: {
					return rejectWithValue({
						httpStatusCode,
						message,
					});
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);


export const addDeliveryManOrder = createAsyncThunk<
  iGenericResponse<any | null> | null,
  { orderId: string; deliveryManId: string },
  { rejectValue: iStateMessage }
>(
  curriedGetThunkName("addDeliveryManOrder"),
  // @ts-expect-error
  async ({ orderId, deliveryManId }, { rejectWithValue }) => {
    try {
      const response = await deliveryManService.addDeliveryManOrder(
        orderId,
        deliveryManId
      );

      if (!response) {
        return rejectWithValue({ message: "No response received" });
      }

      const { httpStatusCode, data, message } = response;

      switch (httpStatusCode) {
        case httpStatusCodes.SUCCESS_OK:
			// @ts-expect-error
        case httpStatusCodes.CREATED:
          return { data, message };

        default:
          return rejectWithValue({
            httpStatusCode,
            message,
          });
      }
    } catch (error) {
      console.error("addDeliveryManOrder error:", error);
      return rejectWithValue({
        message: "Something went wrong",
      });
    }
  }
);
